import React, { FunctionComponent, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { DropdownField } from '@trainline/depot-web';

import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from '@contactcentre-web/common/Modal';
import Button from '@contactcentre-web/common/Button';

import { BlockReason } from './ProfileStatus';
import messages from './messages';

interface Props {
  visible: boolean;
  onClose: () => void;
  blockAccount: (reason: BlockReason) => void;
}

const BlockAccount: FunctionComponent<Props> = ({ visible, onClose, blockAccount }) => {
  if (!visible) return null;
  const intl = useIntl();

  const blockReasons = [
    { text: intl.formatMessage(messages.paymentFailed), value: BlockReason.PaymentFailed },
    {
      text: intl.formatMessage(messages.fraudThresholdExceeded),
      value: BlockReason.FraudThresholdExceeded,
    },
  ];
  const [selectedReason, setSelectedReason] = useState(blockReasons[0].value);

  const handleSubmit = () => {
    blockAccount(selectedReason);
    onClose();
  };

  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <ModalTitle>
          <FormattedMessage {...messages.blockAccountTitle} />
        </ModalTitle>
      </ModalHeader>
      <ModalBody>
        <DropdownField
          id="block-reason"
          label={intl.formatMessage(messages.dropdownLabel)}
          items={blockReasons}
          defaultValue={blockReasons[0].value}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            setSelectedReason(e.target.value as BlockReason)
          }
        />
      </ModalBody>
      <ModalFooter>
        <Button variant="destructive" size="small" onClick={handleSubmit}>
          <FormattedMessage {...messages.buttonBlock} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BlockAccount;
